module.exports = __webpack_public_path__ + "static/media/S1-1-Phrozb-cod1.31a2019f.png";